<template>
    <button v-bind="$attrs" class="bg-blue-500 text-white w-full rounded" :class="[btnClass]">
        <slot></slot>
    </button>
</template>
<script>
export default {
    name: 'BlueButton',
    props: {
        customClass: { type: String, default: null },
    },
    computed: {
        btnClass: function() {
            if (this.customClass != null) {
                return this.customClass;
            }
            return 'p-2';
        },
    }
}
</script>
<style lang="scss" scoped>
</style>
